module.exports = __webpack_public_path__ + "static/media/wizualizacja-111.caa6b44e.png";